import React, { FC, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

import InlineContainer from '@ad-scripts/presentation/components/common/containers/inline_container';
import NodesCardList from './NodesCardList';
import TreeData from './ivrTree/models/TreeData';
import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import { StyledConfirmOrCancelModal } from 'src/presentation/components/pages/shared/rowActions/StyledConfirmOrCancelModal';

const TitleIfNodeWithoutChildren = (
  <>
    Are you sure you want to
    <br /> delete this node?
  </>
);

const TitleIfNodeHasChildren = (
  <>
    If you delete this node, other
    <br /> nodes will be disconnected
  </>
);

type DeleteNodeButtonProps = {
  nodeId: string;
  onDelete: () => void;
  treeData?: TreeData;
};

const DeleteNodeButton: FC<DeleteNodeButtonProps> = ({ nodeId, treeData, onDelete }) => {
  const [confirmModalIsVisible, setConfirmModalIsVisible] = useState(false);

  const childrenList = treeData ? treeData.getAllChildren(nodeId) : [];
  const deleteHandler = () => {
    setConfirmModalIsVisible(false);
    onDelete();
  };

  return (
    <>
      <DeleteButtonContainer>
        <Button
          data-aid="deleteNodeButton"
          buttonType={ButtonTypes.DANGER}
          onClick={() => setConfirmModalIsVisible(true)}
        >
          Delete Node
        </Button>
      </DeleteButtonContainer>

      {confirmModalIsVisible && (
        <StyledConfirmOrCancelModal
          data-aid="delete-node-confirmation-modal"
          onCancel={() => setConfirmModalIsVisible(false)}
          onSubmit={deleteHandler}
          submitButtonType={ButtonTypes.DANGER}
          submitText="Delete"
          text=""
          title={isEmpty(childrenList) ? TitleIfNodeWithoutChildren : TitleIfNodeHasChildren}
        >
          <NodesCardList nodes={childrenList} />
        </StyledConfirmOrCancelModal>
      )}
    </>
  );
};

const DeleteButtonContainer = styled(InlineContainer)`
  justify-content: end;
  padding: 12px 0;
`;

export default DeleteNodeButton;
